import React, { FC, useCallback, useRef, useEffect } from 'react'
import { FieldValues, useForm } from 'react-hook-form'
import { Button } from '@wmgtech/legato'

import { FormTextArea } from 'components/Form/FormTextArea/FormTextArea'
import { EditCommentProps } from './Comment.props'

import styles from './Comment.module.scss'

interface CustomKeyBoardEvent extends Event {
  key: string
  ctrlKey: boolean
  metaKey: boolean
}

const MAX_TEXTAREA_HEIGHT = 600
const EditComment: FC<EditCommentProps> = ({ text, onSubmit, loading }) => {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null)

  const { resetField, handleSubmit, control, watch } = useForm({
    defaultValues: { text }
  })
  const textValue = watch('text')

  const onSubmitHandler = useCallback(
    (data: FieldValues) => {
      onSubmit(data.text, () => resetField('text'))
    },
    [resetField, onSubmit]
  )

  const onSubmitCreate = () => {
    handleSubmit(onSubmitHandler)()
  }

  useEffect(() => {
    const onHitCtrlEnter = (event: CustomKeyBoardEvent) => {
      if (event.key === 'Enter' && (event.ctrlKey || event.metaKey)) {
        handleSubmit(onSubmitHandler)()
      }
    }

    if (textareaRef?.current) {
      textareaRef.current.addEventListener('keydown', onHitCtrlEnter)
    }
  }, [handleSubmit, onSubmitHandler])

  useEffect(() => {
    if (textareaRef?.current) {
      textareaRef.current.style.overflowY = 'hidden'
      textareaRef.current.style.height = 'auto'
      textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px'

      if (parseInt(textareaRef.current.style.height) > MAX_TEXTAREA_HEIGHT) {
        textareaRef.current.style.overflowY = 'auto'
      }
    }
  }, [textValue])

  return (
    <div className={styles.commentArea}>
      <FormTextArea
        control={control}
        fieldName="text"
        className={styles.commentTextArea}
        textareaRef={textareaRef}
        placeholder="Leave context..."
        rows={1}
      />
      <Button
        className={styles.commentSaveArea}
        label="Save"
        colorType="secondary-black"
        containerStyle="link"
        size="md"
        disabled={loading}
        onClick={onSubmitCreate}
      />
    </div>
  )
}

export default EditComment
